import { useCallback, useState } from 'react'

/**
 * Kleinigkeiten, die am Gerät hängen und nicht am Konto.
 *
 * Ob eine Reise eingeklappt ist und ob die abgeschlossenen Reisen offen
 * stehen, ist Ansichtssache -- wörtlich, und am Telefon eine andere als am
 * Schreibtisch. Auf dem Server hätte das nichts zu suchen: es wäre eine
 * Tabelle, eine Abfrage und ein Endpunkt für etwas, das niemand vermisst,
 * wenn es beim Gerätewechsel verloren geht.
 *
 * `localStorage` kann werfen -- in privaten Fenstern und bei abgeschaltetem
 * Speicher. Dann bleibt es bei der Vorgabe, statt dass die Liste weiß wird.
 */
export function usePreference<T>(key: string, fallback: T): [T, (wert: T) => void] {
  const [wert, setWert] = useState<T>(() => {
    try {
      const roh = localStorage.getItem(key)
      return roh === null ? fallback : (JSON.parse(roh) as T)
    } catch {
      return fallback
    }
  })

  const merken = useCallback(
    (neu: T) => {
      setWert(neu)
      try {
        localStorage.setItem(key, JSON.stringify(neu))
      } catch {
        // Nicht speichern zu können ist kein Grund, nicht zu bedienen.
      }
    },
    [key],
  )

  return [wert, merken]
}
